'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CwImage = require('../../components/cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFileImage = require('./CwFileImage.scss');

var _CwFileImage2 = _interopRequireDefault(_CwFileImage);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFileImage = function (_Component) {
  (0, _inherits3.default)(CwFileImage, _Component);

  function CwFileImage(props) {
    (0, _classCallCheck3.default)(this, CwFileImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwFileImage.__proto__ || (0, _getPrototypeOf2.default)(CwFileImage)).call(this, props));

    _this.readFile = function (file) {
      // read in as binary blob for src
      var reader = new FileReader();

      reader.onload = function (event) {
        _this.setState({ src: event.target.result });
      };

      reader.readAsDataURL(file);
    };

    _this.state = { src: null };
    return _this;
  }

  (0, _createClass3.default)(CwFileImage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.file) {
        this.readFile(this.props.file);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // check to see if file has changed
      if (nextProps.file && this.props.file !== nextProps.file) {
        this.readFile(nextProps.file);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.src) {
        return _react2.default.createElement('div', { className: (0, _classnames2.default)(this.props.className, _CwFileImage2.default.loading) });
      }

      return _react2.default.createElement(_CwImage2.default, {
        src: this.state.src,
        isInlineSVG: false,
        className: this.props.className
      });
    }
  }]);
  return CwFileImage;
}(_react.Component);

CwFileImage.propTypes = {
  className: _propTypes2.default.string,
  file: _propTypes2.default.object
};

exports.default = CwFileImage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwfileimage/CwFileImage.js
// module id = 367
// module chunks = 10